export const OHL = {
    name: 'DV 252 TS BEOGRAD 3 -TS BEOGRAD 8',
    voltage: '220',
    regionCode: 'BGD',
    stubovi: [
        { index: 1, name: 'P-01', lat: 44.721 , lng: 20.4666, sys: 1, portal: true },
        { index: 2, name: '1', lat: 44.7216 , lng: 20.4667, sys: 1},
        { index: 3, name: '2', lat: 44.7213 , lng: 20.4692, sys: 1},
        { index: 4, name: '3', lat: 44.7209 , lng: 20.4731, sys: 1},
        { index: 5, name: '4', lat: 44.7206 , lng: 20.4759, sys: 1},
        { index: 6, name: '5', lat: 44.7196 , lng: 20.4837, sys: 1},
        { index: 7, name: '6', lat: 44.7191 , lng: 20.4881, sys: 1},
        { index: 8, name: '7', lat: 44.7188 , lng: 20.4915, sys: 1},
        { index: 9, name: '8', lat: 44.7172 , lng: 20.4966, sys: 1},
        { index: 10, name: '9', lat: 44.7191 , lng: 20.5009, sys: 1},
        { index: 11, name: '10', lat: 44.721 , lng: 20.5048, sys: 1},
        { index: 12, name: '11', lat: 44.7219 , lng: 20.5069, sys: 1},
        { index: 13, name: '12', lat: 44.7234 , lng: 20.51, sys: 1},
        { index: 14, name: '13', lat: 44.7254 , lng: 20.514, sys: 1},
        { index: 15, name: '14', lat: 44.7268 , lng: 20.5168, sys: 1},
        { index: 16, name: '15', lat: 44.729 , lng: 20.5215, sys: 1},
        { index: 17, name: '16', lat: 44.7319 , lng: 20.5275, sys: 1},
        { index: 18, name: '17', lat: 44.7332 , lng: 20.5303, sys: 1},
        { index: 19, name: '18', lat: 44.7384 , lng: 20.5355, sys: 1},
        { index: 20, name: '19', lat: 44.7388 , lng: 20.5425, sys: 1},
        { index: 21, name: '20', lat: 44.7392 , lng: 20.5483, sys: 1},
        { index: 22, name: '21', lat: 44.7394 , lng: 20.5516, sys: 1},
        { index: 23, name: '22', lat: 44.7397 , lng: 20.5562, sys: 1},
        { index: 24, name: '23', lat: 44.74 , lng: 20.5604, sys: 1},
        { index: 25, name: '24', lat: 44.74 , lng: 20.5653, sys: 1},
        { index: 26, name: '25', lat: 44.74 , lng: 20.5706, sys: 1},
        { index: 27, name: '26', lat: 44.74 , lng: 20.5752, sys: 1},
        { index: 28, name: '27', lat: 44.74 , lng: 20.5799, sys: 1},
        { index: 29, name: '28', lat: 44.7386 , lng: 20.5822, sys: 1},
        { index: 30, name: '29', lat: 44.7368 , lng: 20.5852, sys: 1},
        { index: 31, name: 'P-99', lat: 44.7362 , lng: 20.5863, sys: 1, portal: true }    
    ],
    rasponi: [
        { name: 'P-01 - 1', position: [{ lat: 44.721 , lng: 20.4666 }, { lat: 44.7216 , lng: 20.4667 }] },
        { name: '1 - 2', position: [{ lat: 44.7216 , lng: 20.4667 }, { lat: 44.7213 , lng: 20.4692 }] },
        { name: '2 - 3', position: [{ lat: 44.7213 , lng: 20.4692 }, { lat: 44.7209 , lng: 20.4731 }] },
        { name: '3 - 4', position: [{ lat: 44.7209 , lng: 20.4731 }, { lat: 44.7206 , lng: 20.4759 }] },
        { name: '4 - 5', position: [{ lat: 44.7206 , lng: 20.4759 }, { lat: 44.7196 , lng: 20.4837 }] },
        { name: '5 - 6', position: [{ lat: 44.7196 , lng: 20.4837 }, { lat: 44.7191 , lng: 20.4881 }] },
        { name: '6 - 7', position: [{ lat: 44.7191 , lng: 20.4881 }, { lat: 44.7188 , lng: 20.4915 }] },
        { name: '7 - 8', position: [{ lat: 44.7188 , lng: 20.4915 }, { lat: 44.7172 , lng: 20.4966 }] },
        { name: '8 - 9', position: [{ lat: 44.7172 , lng: 20.4966 }, { lat: 44.7191 , lng: 20.5009 }] },
        { name: '9 - 10', position: [{ lat: 44.7191 , lng: 20.5009 }, { lat: 44.721 , lng: 20.5048 }] },
        { name: '10 - 11', position: [{ lat: 44.721 , lng: 20.5048 }, { lat: 44.7219 , lng: 20.5069 }] },
        { name: '11 - 12', position: [{ lat: 44.7219 , lng: 20.5069 }, { lat: 44.7234 , lng: 20.51 }] },
        { name: '12 - 13', position: [{ lat: 44.7234 , lng: 20.51 }, { lat: 44.7254 , lng: 20.514 }] },
        { name: '13 - 14', position: [{ lat: 44.7254 , lng: 20.514 }, { lat: 44.7268 , lng: 20.5168 }] },
        { name: '14 - 15', position: [{ lat: 44.7268 , lng: 20.5168 }, { lat: 44.729 , lng: 20.5215 }] },
        { name: '15 - 16', position: [{ lat: 44.729 , lng: 20.5215 }, { lat: 44.7319 , lng: 20.5275 }] },
        { name: '16 - 17', position: [{ lat: 44.7319 , lng: 20.5275 }, { lat: 44.7332 , lng: 20.5303 }] },
        { name: '17 - 18', position: [{ lat: 44.7332 , lng: 20.5303 }, { lat: 44.7384 , lng: 20.5355 }] },
        { name: '18 - 19', position: [{ lat: 44.7384 , lng: 20.5355 }, { lat: 44.7388 , lng: 20.5425 }] },
        { name: '19 - 20', position: [{ lat: 44.7388 , lng: 20.5425 }, { lat: 44.7392 , lng: 20.5483 }] },
        { name: '20 - 21', position: [{ lat: 44.7392 , lng: 20.5483 }, { lat: 44.7394 , lng: 20.5516 }] },
        { name: '21 - 22', position: [{ lat: 44.7394 , lng: 20.5516 }, { lat: 44.7397 , lng: 20.5562 }] },
        { name: '22 - 23', position: [{ lat: 44.7397 , lng: 20.5562 }, { lat: 44.74 , lng: 20.5604 }] },
        { name: '23 - 24', position: [{ lat: 44.74 , lng: 20.5604 }, { lat: 44.74 , lng: 20.5653 }] },
        { name: '24 - 25', position: [{ lat: 44.74 , lng: 20.5653 }, { lat: 44.74 , lng: 20.5706 }] },
        { name: '25 - 26', position: [{ lat: 44.74 , lng: 20.5706 }, { lat: 44.74 , lng: 20.5752 }] },
        { name: '26 - 27', position: [{ lat: 44.74 , lng: 20.5752 }, { lat: 44.74 , lng: 20.5799 }] },
        { name: '27 - 28', position: [{ lat: 44.74 , lng: 20.5799 }, { lat: 44.7386 , lng: 20.5822 }] },
        { name: '28 - 29', position: [{ lat: 44.7386 , lng: 20.5822 }, { lat: 44.7368 , lng: 20.5852 }] },
        { name: '29 - P-99', position: [{ lat: 44.7368 , lng: 20.5852 }, { lat: 44.7362 , lng: 20.5863 }] }
    ],
    stanice: [{name: 'Beograd 3', position: {lat: 44.7201 , lng: 20.4656}}, {name: 'Beograd 8', position: {lat: 44.7358 , lng: 20.5874}}]
}
